/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DspDealAPI {

  /**
   * Method that creates a new dsp deal
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiDspDeal(
    requestBody: {
      id?: number;
      dealid?: string;
      description?: string;
      dsp_id: number;
      campaign_id: number;
      bid_floor?: number | null;
      auction_type?: number;
    },
  ): CancelablePromise<{
    id: number;
    dealid: string;
    description: string;
    dsp_id: number;
    campaign_id: number;
    bid_floor: number | null;
    auction_type: number;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dsp_deal',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a particular dsp deal
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiDspDeal(
    requestBody: {
      id: number;
      dealid?: string;
      description?: string;
      dsp_id?: number;
      campaign_id?: number;
      bid_floor?: number | null;
      auction_type?: number;
    },
  ): CancelablePromise<{
    id: number;
    dealid: string;
    description: string;
    dsp_id: number;
    campaign_id: number;
    bid_floor: number | null;
    auction_type: number;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dsp_deal',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a particular dsp deal
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiDspDeal(
    id: number,
  ): CancelablePromise<{
    id: number;
    dealid: string;
    description: string;
    dsp_id: number;
    campaign_id: number;
    bid_floor: number | null;
    auction_type: number;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dsp_deal/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of dsp deal
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param dealid
   * @param dspId
   * @param campaignId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiDspDealList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    dealid?: Array<string>,
    dspId?: Array<number>,
    campaignId?: Array<number>,
  ): CancelablePromise<Array<{
    id: number;
    dealid: string;
    description: string;
    dsp_id: number;
    campaign_id: number;
    bid_floor: number | null;
    auction_type: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dsp_deal/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'dealid': dealid,
        'dsp_id': dspId,
        'campaign_id': campaignId,
      },
    });
  }

  /**
   * Method that set all advertiser domains for a given dsp deal
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiDspDealAdvertiserDomains(
    id: number,
    requestBody: {
      advertiser_domain_ids: Array<number>;
    },
  ): CancelablePromise<Array<{
    id: number;
    deal_id: number;
    advertiser_domain_id: number;
  }>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dsp_deal/{id}/advertiser_domains',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that set all formats for a given dsp deal
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiDspDealFormats(
    id: number,
    requestBody: {
      format_ids: Array<number>;
    },
  ): CancelablePromise<Array<{
    id: number;
    format_id: number;
    deal_id: number;
  }>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dsp_deal/{id}/formats',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that set all seats for a given dsp deal
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiDspDealSeats(
    id: number,
    requestBody: {
      seat_ids: Array<number>;
    },
  ): CancelablePromise<Array<{
    id: number;
    deal_id: number;
    seat_id: number;
  }>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dsp_deal/{id}/seats',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
